import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-110">
              <i className="ri-book-open-line text-lg text-white"></i>
            </div>
            <span className={`font-heading text-lg font-bold transition-colors duration-300 ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              韩国漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-all duration-200 whitespace-nowrap ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/70'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm transition-colors duration-200 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-900'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <Link
              to="/category/all"
              className="px-5 py-2 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome
                ? 'text-foreground-700 hover:bg-background-200'
                : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                className="px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
              >
                {cat.label}
              </Link>
            ))}
            <div className="border-t border-background-200/70 my-2"></div>
            <Link
              to="/about"
              className="px-4 py-2.5 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/category/all"
              className="px-4 py-2.5 text-sm font-medium text-center bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors mt-2 whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}